import { Editor } from 'primereact/editor';
import { FileUpload } from 'primereact/fileupload';

import {
  convertHtmlToPlainText,
  sanitizeHtml,
} from '@src/main/modules/other_incidents/ui/hooks/useIncidentUtils';

type IncidentEmailSectionProps = {
  emailText: string;
  setEmailText: (value: string) => void;
  setPlainText: (value: string) => void;
  setFile: (file: File | null) => void;
  t: (key: string) => string;
  uploadKey: number;
};

export const IncidentEmailSection = ({
  emailText,
  setEmailText,
  setPlainText,
  setFile,
  t,
  uploadKey,
}: IncidentEmailSectionProps) => (
  <>
    <div style={{ marginTop: '2rem' }}>
      <b>{t('otherIncidentManagement.incidentDetail.message')}</b>
    </div>

    <div style={{ marginTop: '2rem' }}>
      <Editor
        value={emailText}
        onTextChange={(e) => {
          const htmlValue = e.htmlValue ?? '';
          const sanitizedHtml = sanitizeHtml(htmlValue);
          const textValue = convertHtmlToPlainText(sanitizedHtml);
          setEmailText(htmlValue);
          setPlainText(textValue);
        }}
        style={{ height: '220px', marginTop: '1rem', fontSize: '25px' }}
        placeholder={t('common.editorPlaceholder')}
      />
    </div>

    <FileUpload
      key={uploadKey}
      name="file"
      chooseLabel={t('common.attachFile')}
      mode="advanced"
      auto
      multiple={false}
      maxFileSize={600000}
      onSelect={(e) => {
        const file = e.files[0];
        setFile(file);
      }}
    />
  </>
);
